<template>
  <el-dialog
    top="3vh"
    :visible.sync="this.$root.crudCargoDetailDialog"
    :before-close="handleBeforeClose"
    custom-class="cargo-crud-dialog"
    append-to-body
    :show-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template slot="title">
      <div class="cargo-crud-dialog__head">
        <div class="cargo-crud-dialog__head-icon" aria-hidden="true">
          <i class="el-icon-box" />
        </div>
        <div class="cargo-crud-dialog__head-text">
          <span class="cargo-crud-dialog__kicker">{{ ruleForm.id ? 'Явц' : 'Шинэ бүртгэл' }}</span>
          <span class="cargo-crud-dialog__title">{{ ruleForm.id ? 'Ачааны явц оруулах' : 'Ачаа нэмэх' }}</span>
          <span class="cargo-crud-dialog__sub">{{ ruleForm.id ? 'Мэдээллээ шинэчилж хадгална уу' : 'Зураг болон талбаруудыг бөглөнө үү' }}</span>
        </div>
      </div>
    </template>

    <el-form :model="ruleForm" label-position="top" class="cargo-crud-dialog__form">
      <div class="cargo-crud-dialog__panel cargo-crud-dialog__panel--media">
        <div class="cargo-crud-dialog__section-label">
          <i class="el-icon-picture-outline" />
          Зураг
        </div>
        <p class="cargo-crud-dialog__hint">Нэг дор олон зураг сонгож болно (хамгийн ихдээ 50).</p>
        <el-form-item prop="image_path" class="cargo-crud-dialog__field cargo-crud-dialog__field--upload">
          <div class="cargo-crud-dialog__upload">
            <DynamicUploadImage />
          </div>
        </el-form-item>
      </div>

      <div class="cargo-crud-dialog__panel">
        <div class="cargo-crud-dialog__section-label">
          <i class="el-icon-document" />
          Үндсэн мэдээлэл
        </div>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item v-if="checkPermissionsPage('app_cargo_company_add')" label="Байгууллага" class="cargo-crud-dialog__field">
              <el-select
                v-model="ruleForm.company_id"
                class="cargo-crud-dialog__control"
                placeholder="Байгууллага сонгох"
                filterable
                clearable
                @change="getBranch"
              >
                <el-option
                  v-for="(item, index) in companyList"
                  :key="index"
                  :value="item.id"
                  :label="item.company_name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.company_id === 1" :span="24">
            <el-form-item v-if="checkPermissionsPage('app_cargo_branch_add')" label="Салбар" class="cargo-crud-dialog__field">
              <el-select
                v-model="ruleForm.branch"
                class="cargo-crud-dialog__control"
                placeholder="Салбар сонгох"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in branchList"
                  :key="index"
                  :value="item.branch_name"
                  :label="item.branch_name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="checkPermissionsPage('app_cargo_yuan_add')" :span="24">
            <el-form-item label="Үнэ (юань)" class="cargo-crud-dialog__field">
              <el-input
                v-model="ruleForm.yuan"
                class="cargo-crud-dialog__control"
                type="text"
                inputmode="decimal"
                autocomplete="off"
                placeholder="0"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="checkPermissionsPage('app_cargo_insert_mkub_add')" :span="24">
            <el-form-item label="Метр куб" class="cargo-crud-dialog__field">
              <el-input
                v-model="ruleForm.mkub"
                class="cargo-crud-dialog__control"
                type="text"
                inputmode="decimal"
                autocomplete="off"
                placeholder="м³"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="checkPermissionsPage('app_cargo_gargasan_too_add')" :span="24">
            <el-form-item label="Гаргасан тоо" class="cargo-crud-dialog__field">
              <el-input
                v-model="ruleForm.count"
                class="cargo-crud-dialog__control"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                autocomplete="off"
                placeholder="Тоо"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="checkPermissionsPage('app_cargo_hvleen_awsan_too_add')" :span="24">
            <el-form-item label="Тоо" class="cargo-crud-dialog__field">
              <el-input
                v-model="ruleForm.huleen_awsan_too"
                class="cargo-crud-dialog__control"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                autocomplete="off"
                placeholder="Хүлээн авсан / тоо"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="checkPermissionsPage('app_cargo_phone_add')" :span="24">
            <el-form-item label="Утасны дугаар" class="cargo-crud-dialog__field">
              <el-input
                v-model="ruleForm.phone"
                class="cargo-crud-dialog__control"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                autocomplete="tel"
                placeholder="8xxxxxxxx"
                maxlength="20"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Тайлбар" class="cargo-crud-dialog__field">
              <el-input
                v-model="ruleForm.description"
                class="cargo-crud-dialog__control"
                type="textarea"
                :rows="3"
                resize="none"
                placeholder="Нэмэлт тайлбар бичнэ үү"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="cargo-crud-dialog__actions">
        <el-button
          v-if="checkPermissionsPage('app_cargo_save_100')"
          class="cargo-crud-dialog__btn cargo-crud-dialog__btn--primary"
          type="success"
          @click="cargoSave(100)"
        >
          Хадгалах
        </el-button>
        <el-button
          v-if="checkPermissionsPage('app_cargo_save_110')"
          class="cargo-crud-dialog__btn"
          type="success"
          plain
          @click="cargoSave(110)"
        >
          Ачаа хүлээн авах
        </el-button>
        <el-button
          v-if="checkPermissionsPage('app_cargo_save_130')"
          class="cargo-crud-dialog__btn"
          type="success"
          @click="cargoSave(130)"
        >
          Хадгалах
        </el-button>
        <el-button
          v-if="checkPermissionsPage('app_cargo_save_140') && this.ruleForm.ruleForm === 130"
          class="cargo-crud-dialog__btn"
          type="success"
          @click="cargoSave(140)"
        >
          Хадгалах
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import services from '@/helpers/services'
import DynamicUploadImage from '@/components/dynamicUploadImage.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { checkPermissions } from '@/helpers/custom'

export default {
  data () {
    return {
      ruleForm: {
        id: this.selectedCargoDetailId,
        yuan: null,
        count: null,
        company_id: null,
        description: null,
        img_path: null,
        is_paid: false,
        branch: null,
        mkub: null,
        huleen_awsan_too: null,
        status: null,
        phone: null
      },
      companyList: [],
      branchList: []
    }
  },
  props: {
    selectedCargoDetailId: {
      type: Number,
      default: null
    },
    isShowImage: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    ...mapGetters(['imgUrlGetter']),
    ...mapState({
      dynamic_img_url: state => state.dynamic_img_url
    })
  },
  components: {
    DynamicUploadImage
  },
  created () {
    this.replaceDynamicImgUrl([])
    this.getCompanies()
    if (this.ruleForm.id != null) {
      this.getCargoDetail()
    }
    if (!this.checkPermissionsPage('app_cargo_company_add')) {
      this.ruleForm.img_path = null
    }
  },
  watch: {
    dynamic_img_url () {
      this.ruleForm.img_path = this.normalizeImagePaths(this.imgUrlGetter)
    }
  },
  methods: {
    ...mapActions(['replaceDynamicImgUrl']),
    normalizeImagePaths (value) {
      if (value == null || value === '') return []
      if (Array.isArray(value)) return value.filter(Boolean)
      if (typeof value === 'string') {
        const t = value.trim()
        if (!t) return []
        if (t.startsWith('[')) {
          try {
            const p = JSON.parse(t)
            return Array.isArray(p) ? p.filter(Boolean) : [t]
          } catch (_) {
            return [t]
          }
        }
        return [t]
      }
      return []
    },
    getCargoDetail () {
      services.getCargoProgressById(this.selectedCargoDetailId)
        .then((response) => {
          if (this.isShowImage === false) {
            this.ruleForm.img_path = null
            this.ruleForm.description = null
          } else {
            this.ruleForm.id = response.data.id
            this.ruleForm.yuan = response.data.yuan
            this.ruleForm.count = response.data.count
            const companyId = response.data.company_id || response.data.Company?.id || null
            this.ruleForm.company_id = companyId
            this.ruleForm.description = response.data.description
            this.ruleForm.is_paid = response.data.is_paid
            this.ruleForm.branch = response.data.branch
            this.ruleForm.mkub = response.data.mkub
            this.ruleForm.huleen_awsan_too = response.data.huleen_awsan_too
            this.ruleForm.phone = response.data.phone
            this.ruleForm.status = response.data.status
            const sortedStatuses = Array.isArray(response.data.CargoStatus)
              ? [...response.data.CargoStatus].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
              : []
            const latestStatus = sortedStatuses[sortedStatuses.length - 1]
            const latestImages = (latestStatus && Number(latestStatus.status) === 100)
              ? this.normalizeImagePaths(latestStatus.img_path)
              : []
            const latesDescription = (latestStatus && Number(latestStatus.status) === 100)
              ? this.ruleForm.description = latestStatus.description
              : null
            this.ruleForm.img_path = latestImages
            this.ruleForm.description = latesDescription
            this.replaceDynamicImgUrl(latestImages)
            if (companyId) {
              services.getBranches({ companyId })
                .then(branchResponse => {
                  this.branchList = branchResponse.data
                })
                .catch((error) => {
                  console.error('branches error:', error)
                })
            }
          }
        })
        .catch((error) => {
          console.error('branches error:', error)
        })
    },
    getBranch () {
      const companyId = this.ruleForm.company_id
      // Reset branch state on company change
      this.ruleForm.branch = null
      this.branchList = []
      if (!companyId) return
      services.getBranches({ companyId })
        .then((response) => {
          this.branchList = response.data
        })
        .catch((error) => {
          console.error('branches error:', error)
        })
    },
    /** Зөвхөн X (header close) — overlay / ESC-ээр хаагдахгүй */
    handleBeforeClose (done) {
      this.$root.crudCargoDetailDialog = false
      if (typeof done === 'function') done()
    },
    hasImage () {
      return this.normalizeImagePaths(this.ruleForm.img_path).length > 0
    },
    returnStatusValue (data) {
      const result = this.$root.cargoStatus.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    },
    getCompanies () {
      services.getCompanies()
        .then((response) => {
          // Мөөгий (8) болон 7588 (9) нэг харилцагч — жагсаалтад зөвхөн нэг харуулна
          const MERGE_PRIMARY_ID = 8
          const MERGE_HIDE_IDS = new Set([9])
          const MERGE_HIDE_NAMES = new Set(['7588'])
          const MERGE_LABEL = 'Мөөгий / 7588'
          const rows = Array.isArray(response?.data) ? response.data : []
          this.companyList = rows
            .filter((item) => {
              const id = Number(item.id)
              const name = String(item.company_name || '').trim()
              if (MERGE_HIDE_IDS.has(id)) return false
              if (MERGE_HIDE_NAMES.has(name)) return false
              return true
            })
            .map((item) => (
              Number(item.id) === MERGE_PRIMARY_ID
                ? { ...item, company_name: MERGE_LABEL }
                : item
            ))
        })
    },
    async cargoSave (data) {
      try {
        this.$root.fullscreenLoading = true
        this.ruleForm.status = data
        if (!this.hasImage()) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Зураг оруулна уу',
            type: 'error',
            position: 'top-left'
          })
        }
        if (this.ruleForm.status === 100 && !this.ruleForm.yuan) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Юань оруулна уу',
            type: 'error',
            position: 'top-left'
          })
        }
        if (this.ruleForm.status === 100 && !this.ruleForm.company_id) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Байгууллага сонгоно уу',
            type: 'error',
            position: 'top-left'
          })
        }
        if (this.ruleForm.status === 100 && !this.ruleForm.mkub) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Метр куб оруулна уу',
            type: 'error',
            position: 'top-left'
          })
        }
        if (this.ruleForm.status === 100 && !this.ruleForm.phone) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Гаргасан утасны дугаар оруулна уу',
            type: 'error',
            position: 'top-left'
          })
        }
        if (this.ruleForm.status === 100 && !this.ruleForm.count) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Гаргасан тоо оруулна уу',
            type: 'error',
            position: 'top-left'
          })
        }
        if (this.ruleForm.status === 110 && !this.ruleForm.huleen_awsan_too) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Хүлээн авсан тоо оруулна уу',
            type: 'error',
            position: 'top-left'
          })
        }
        if (this.ruleForm.status === 120 && !this.ruleForm.huleen_awsan_too) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Салбарт хүлээлгэн өгсөн тоо оруулна уу',
            type: 'error',
            position: 'top-left'
          })
        }
        if (this.ruleForm.status === 130 && !this.ruleForm.huleen_awsan_too) {
          this.$root.fullscreenLoading = false
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Хүлээн авсан тоо оруулна уу',
            type: 'error',
            position: 'top-left'
          })
        }
        await services.createdCargo(this.ruleForm)
          .then((response) => {
            if (response.type === 'success') {
              this.$root.fullscreenLoading = false
              this.$notify({
                title: 'Амжилттай',
                message: 'Ачаа амжилттай бүртгэгдлээ. Дууссаны дараа баруун дээд талын X дарж хаана уу.',
                type: 'success',
                position: 'top-left'
              })
            }
          }).catch((error) => {
            console.error('Алдаа:', error)
            this.$root.fullscreenLoading = false
            this.$notify({
              title: 'Амжилтгүй',
              message: error.message,
              type: 'error',
              position: 'top-left'
            })
          })
      } catch (error) {
        alert(error)
      }
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    }
  }
}
</script>

<style>
.cargo-crud-dialog.el-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  max-width: 440px;
  width: 92% !important;
  margin-top: 3vh !important;
}

.cargo-crud-dialog .el-dialog__header {
  padding: 18px 20px 14px;
  background: linear-gradient(135deg, #eff6ff 0%, #e0e7ff 42%, #f0fdf4 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.35);
}

.cargo-crud-dialog .el-dialog__title {
  width: 100%;
  line-height: 1.25;
}

.cargo-crud-dialog .el-dialog__body {
  padding: 0 0 18px;
  background: #f1f5f9;
  max-height: min(78vh, 640px);
  overflow-y: auto;
}

.cargo-crud-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 12px;
}

.cargo-crud-dialog__head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding-right: 32px;
}

.cargo-crud-dialog__head-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(145deg, #fff 0%, #e0e7ff 100%);
  border: 1px solid rgba(99, 102, 241, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4f46e5;
  font-size: 22px;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.12);
}

.cargo-crud-dialog__head-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.cargo-crud-dialog__kicker {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #6366f1;
  font-weight: 600;
}

.cargo-crud-dialog__title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #0f172a;
}

.cargo-crud-dialog__sub {
  font-size: 13px;
  color: #64748b;
  line-height: 1.45;
}

.cargo-crud-dialog__form {
  padding: 0;
}

.cargo-crud-dialog__panel {
  margin: 14px 16px 0;
  background: #fff;
  border-radius: 14px;
  padding: 14px 16px 16px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.cargo-crud-dialog__panel--media {
  padding-bottom: 12px;
}

.cargo-crud-dialog__section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 10px;
}

.cargo-crud-dialog__section-label i {
  font-size: 14px;
  color: #64748b;
}

.cargo-crud-dialog__hint {
  margin: -4px 0 12px;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
}

.cargo-crud-dialog__field {
  margin-bottom: 6px;
}

.cargo-crud-dialog__field--upload {
  margin-bottom: 0;
}

.cargo-crud-dialog__field--upload .el-form-item__content {
  line-height: normal;
}

.cargo-crud-dialog__upload {
  width: 100%;
}

.cargo-crud-dialog__upload .el-upload--picture-card,
.cargo-crud-dialog__upload .el-upload-list--picture-card .el-upload-list__item {
  border-radius: 10px !important;
}

.cargo-crud-dialog__form .el-form-item__label {
  padding-bottom: 4px !important;
  line-height: 1.3 !important;
  color: #475569 !important;
  font-weight: 500;
  font-size: 13px;
}

.cargo-crud-dialog__control {
  width: 100%;
}

.cargo-crud-dialog__control .el-input__inner,
.cargo-crud-dialog__control .el-textarea__inner {
  border-radius: 10px !important;
}

.cargo-crud-dialog__actions {
  margin: 16px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.cargo-crud-dialog__btn {
  width: 100%;
  margin: 0 !important;
  border-radius: 12px !important;
  font-weight: 600;
  padding: 12px 16px !important;
}

.cargo-crud-dialog__btn--primary {
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.28);
}
</style>
